import {FaCheck} from 'react-icons/fa';

import styled from 'styled-components';

interface ContainerProps {
  full: boolean;
}

interface Props {
  active: boolean;
}

interface CheckBoxProps {
  active: boolean;
}

interface ButtonProps {
  waiting?: boolean;
  active?: boolean;
  themeLess?: boolean;
}

export const Container = styled.div<ContainerProps>`
  padding: 15px;
  border-radius: 8px;
  min-width: ${(props) => (props.full ? 350 : 80)}px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  overflow: hidden;
  background-color: #2c2c2c;
  padding-bottom: 45px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.colors.softGray};
  background-color: ${(props) => props.theme.colors.softGray};
  font-size: 14px;
  margin-bottom: 10px;

  &:focus {
    background-color: ${(props) => props.theme.colors.white};
    outline: 1px solid ${(props) => props.theme.colors.primary};
  }
`;

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 35vh;
  overflow-y: auto;
`;

export const CheckBox = styled.div<CheckBoxProps>`
  padding: 2px;
  width: 18px;
  height: 18px;
  border: 1px solid ${(props) => props.theme.colors.gray};
  border-radius: 3px;
  margin-right: 5px;

  background-color: ${(props) =>
    props.active ? props.theme.colors.primary : props.theme.colors.white};

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Active = styled(FaCheck)`
  color: ${(props) => props.theme.colors.white};
  background-color: ${(props) => props.theme.colors.primary};
`;

export const Option = styled.div<Props>`
  height: 40px;
  padding: 10px 8px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.darkGray};
  justify-content: flex-start;

  &:hover {
    transition: all 0.2s ease-in-out;
    background-color: ${(props) => props.theme.colors.primaryLight};
    color: ${(props) => props.theme.colors.primary};
  }
`;

export const AddButtom = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.white};
  height: 40px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  cursor: pointer;
`;

export const Button = styled.div<ButtonProps>`
  position: relative;
  font-size: 12px;
  font-weight: 600;
  height: 35px;
  min-width: 70px;
  text-align: center;
  width: fit-content;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 8px 10px;
  border-radius: 5px;
  background-color: ${(props) => (props.themeLess ? 'white' : '#2c2c2c')};
  color: ${(props) =>
    props.waiting
      ? props.theme.colors.primary
      : props.active
      ? props.theme.colors.primary
      : 'white'};
  cursor: pointer;
  align-self: flex-start;
  border: 1px solid
    ${(props) =>
      props.waiting
        ? props.theme.colors.primary
        : props.active
        ? props.theme.colors.primary
        : props.theme.colors.inputBorder};
  word-break: break-all;

  &:hover {
    color: ${(props) => props.theme.colors.primary};
    border: 1px solid ${(props) => props.theme.colors.primary};
  }
`;
